module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "github.12d0b60b.svg";